<div
    fxLayout
    fxLayout.lt-md="column"
    class="p-t-sm"
    data-testid="doc-header"
    fxLayoutAlign="space-between center"
    fxLayoutAlign.lt-md="start stretch"
    fxLayoutGap="12px">
    @let _headerInfo = data();
    @let _currentContractName = currentContractName();
    @if (currentModule()?.perContract) {
        <div data-testid="doc-header-contract-section">
            <p>{{ contractsName() }}</p>
            <p class="cipo-text--bold-md" data-testid="doc-header-contract-name">{{ _currentContractName }}</p>
        </div>
    }
    @if (_headerInfo.ballInCourt) {
        <div data-testid="doc-header-bic-section">
            <p>{{ "general.BIC" | translate }}</p>
            <p class="cipo-text--bold-md" data-testid="doc-header-bic">
                {{ ballInCourtOrgNames() }}
            </p>
        </div>
        <div data-testid="doc-header-role-section">
            <p>{{ "roles.role" | translate }}</p>
            <p class="cipo-text--bold-md" data-testid="doc-header-role">
                {{ ballInCourtRoles() }}
            </p>
        </div>
    }
    @if (_headerInfo.entityInstanceId) {
        <div data-testid="doc-header-state-section">
            <p>{{ "MODULE.DISPLAY_TYPE.Status" | translate }}</p>
            @if (_headerInfo) {
                <cipo-state
                    data-testid="doc-header-state"
                    [bgColor]="_headerInfo.stateColor"
                    [name]="_headerInfo.state"
                    [textColor]="_headerInfo.stateTextColor" />
            } @else if (_headerInfo === null) {
                <ngx-skeleton-loader [theme]="{ width: '100%', height: '16px', margin: '10' }"></ngx-skeleton-loader>
            } @else {
                <p class="cipo-text--bold-md">-</p>
            }
        </div>
    }
</div>
